module.exports = __webpack_public_path__ + "img/banner3.9ce53c94.png";